import { FormsService } from "../../../services/forms/forms.service";

import { ChangeGeneralSettingActionType } from "../types";
import { getChangedFormGeneralSettings } from "../../../helpers/dataManipulations";

export function* changeGeneralSettingsSaga({ payload }: ChangeGeneralSettingActionType) {
    try {
        yield FormsService.newUpdateForm({
            data: getChangedFormGeneralSettings(payload.prevState, payload.currentState),
        });
    } catch (error) {
        // yield put(Handle Error);
    }
}
